import { Component } from '@angular/core';

@Component({
  selector: 'show-need-top-up',
  templateUrl: './show-need-top-up.component.html',
  styleUrls: ['./show-need-top-up.component.css']
})
export class ShowNeedTopUpComponent {

}
